import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-footer__content container-fluid" }

import AppFooterBusinessHours from '@/components/footer/AppFooterBusinessHours.vue';
import AppFooterCertificates from '@/components/footer/AppFooterCertificates.vue';
import AppFooterContact from '@/components/footer/AppFooterContact.vue';
import AppFooterPhone from '@/components/footer/AppFooterPhone.vue';
import AppFooterSub from '@/components/footer/AppFooterSub.vue';
import AppFooterSocials from '@/components/footer/AppFooterSocials.vue';
import {
  computed, onBeforeMount, ref,
} from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const store = useStore();
const root = ref<InstanceType<typeof HTMLElement>>();

onBeforeMount(() => {
  store.dispatch('menus/fetchBySlug', 'footer');
  store.dispatch('menus/fetchBySlug', 'footer-sub');
});

const menuSub = computed(() => store.getters['menus/menu']('footer-sub'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", {
    ref_key: "root",
    ref: root,
    class: "app-footer d-print-none"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppFooterBusinessHours),
      _createVNode(AppFooterContact),
      _createVNode(AppFooterPhone),
      _createVNode(AppFooterCertificates)
    ]),
    _createVNode(AppFooterSocials),
    _createVNode(AppFooterSub, {
      items: menuSub.value || []
    }, null, 8, ["items"])
  ], 512))
}
}

})